import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import SubHead from "../SubHead";
import Text from "../Text";
import work_1 from "assets/images/work_1.png";
import work_2 from "assets/images/work_2.png";
import { ReactComponent as IconGithub } from "assets/images/icon-github.svg";
import { ReactComponent as IconLink } from "assets/images/icon-link.svg";
import s_1 from "assets/images/s-1.png";
import s_2 from "assets/images/s-2.png";

const Container = styled("section")`
  background-color: var(--primary-color);
  padding: 1rem;

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  .works {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 768px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  p {
    color: var(--font-color);
  }

  h1,
  h2,
  h3 {
    color: var(--font-color);
  }

  @media screen and (min-width: 768px) {
    padding: 4rem;
  }
`;

const Figure = styled("figure")`
  text-align: center;
  width: 92%;
  margin: 0;
  margin-bottom: 80px;

  img {
    width: 92%;
    margin-bottom: 10px;

    @media screen and (min-width: 1024px) {
      width: 75%;
    }
  }

  h3 {
    margin: 0 0 6px;
    font-family: "Lato", sans-serif;
  }

  @media screen and (min-width: 768px) {
    width: 50%;
    margin-bottom: 50px;
  }

  @media screen and (min-width: 992px) {
    h3 {
      font-size: 21px;
    }
  }
`;

const IconWrapper = styled('div')`
    zoom: 0.6;
    display: flex;
    flex-flow: row nowrap;
    margin: 0 0 20px;
    justify-content: center;

    .icon-github {
        /* position: relative;
        top: -3px;
        left: -5px; */
    }
`

const IconBox = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  padding: 8px;
  position: relative;
  margin: 0 10px;
  border: var(--border-width) solid var(--font-color);
  border-radius: 100%;
  cursor: pointer;
  fill: var(--font-color);
`

const SectionWork = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="wrapper">
        <SubHead>{t("work_title")}</SubHead>
      </div>
      <div className="wrapper works">
        <Figure>
          <img src={s_1} alt={t("work_1_title")} />
          <h3>{t("work_1_title")}</h3>
          <Text>{t("work_1_desc")}</Text>
          <IconWrapper>
            <a href="//github.com/iiianous/angular-ts-food" target="_blank" rel="noopener noreferrer" title={t("work_1_title")}>
              <IconBox>
                <IconGithub className="icon-github" />
              </IconBox>
            </a>
            <a href="//food-e6e66.web.app/" target="_blank" rel="noopener noreferrer" title={t("work_1_title")}>
              <IconBox>
                <IconLink width="33" height="33" />
              </IconBox>
            </a>
          </IconWrapper>
        </Figure>
        <Figure>
          <img src={s_2} alt={t("work_2_title")} />
          <h3>{t("work_2_title")}</h3>
          <Text>{t("work_2_desc")}</Text>
          <IconWrapper>
            <a href="//github.com/iiianous/react-ts-agency" target="_blank" rel="noopener noreferrer" title={t("work_2_title")}>
              <IconBox>
                <IconGithub className="icon-github" />
              </IconBox>
            </a>
            <a href="//agency-d0a42.web.app/" target="_blank" rel="noopener noreferrer" title={t("work_2_title")}>
              <IconBox>
                <IconLink width="33" height="33" />
              </IconBox>
            </a>
          </IconWrapper>
        </Figure>
        {/* <Figure>
          <img src={s_2} alt="Balance Spa and Wellness" />
          <h3>{t("work_3_title")}</h3>
          <Text>{t("work_3_desc")}</Text>
          <IconWrapper>
            <a href="//github.com/iiianous/react-ts-eset" target="_blank" rel="noopener noreferrer">
              <IconBox>
                <IconGithub className="icon-github" />
              </IconBox>
            </a>
            <a href="//eset-a7ed1.web.app/" target="_blank" rel="noopener noreferrer">
              <IconBox>
                <IconLink width="33" height="33" />
              </IconBox>
            </a>
          </IconWrapper>
        </Figure> */}
        {/* <Figure>
          <img src={s_1} alt="Psalm23 Basketball Academy" />
          <h3>{t("work_1_title")}</h3>
          <Text>{t("work_1_desc")}</Text>
          <IconWrapper>
            <a href="//github.com/iiianous/angular-ts-food" target="_blank" rel="noopener noreferrer">
              <IconBox>
                <IconGithub className="icon-github" />
              </IconBox>
            </a>
            <a href="//food-e6e66.web.app/" target="_blank" rel="noopener noreferrer">
              <IconBox>
                <IconLink width="33" height="33" />
              </IconBox>
            </a>
          </IconWrapper>
        </Figure> */}
      </div>
    </Container>
  );
};

export default SectionWork;
